import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
const Card = /*#__PURE__*/styled("article")({
  name: "Card",
  class: "c1gx7od7"
});
const Content = /*#__PURE__*/styled("div")({
  name: "Content",
  class: "cwdkis9"
});

const FacilityCardNew = ({
  title,
  location,
  description,
  image,
  type_en,
  type_jp
}) => {
  return <Card>
      <div className="title-container">
        <h1>{type_en}</h1>
        <h2>{type_jp}</h2>
      </div>
      <Content>
        <img src={image} height={225} />
        <div>
          <p className="title">{title}</p>
          <p className="location">{location}</p>
          <div className="divider" />
          <p className="description">{description}</p>
        </div>
      </Content>
    </Card>;
};

export { FacilityCardNew };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");